import { Box, TextField } from "@mui/material";
import { useState } from "react";

interface IProps {
    showRangeTextFields: boolean;
    filterValue: string | null;
    setFilterValue: (value: React.SetStateAction<string | null>) => void;
    labels?: {
        label1?: string;
        label2?: string;
    };
}

export const ConditionalRangeTextFields = ({ showRangeTextFields, filterValue, setFilterValue, labels = {} }: IProps) => {
    const { label1 = showRangeTextFields ? "Value 1" : "Value", label2 = "Value 2" } = labels;

    const parseFilterValue = (filterValue: string | null) => {
        const [value1, value2] = (filterValue || "").split(",");
        return { value1: value1 || "", value2: value2 || "" };
    };

    const [fieldValues, setFieldValues] = useState(() => parseFilterValue(filterValue));//useState({ value1: "", value2: "" });

    const handleInputChange = (field: "value1" | "value2") => (e: React.ChangeEvent<HTMLInputElement>) => {
        const targetValue = e.target.value.trim();

        setFieldValues((prevValues) => {
            const updatedValues = { ...prevValues, [field]: targetValue };

            // Combine only visible field values
            const combinedValue = [
                updatedValues.value1,
                showRangeTextFields ? updatedValues.value2 : null // Include value2 only if it's visible
            ]
                .filter((val) => val) // Remove empty or null values
                .join(",");

                setFilterValue(combinedValue || null);
                
            return updatedValues;
        });
    };

    return (
        <Box display="flex" flexDirection="column" gap={2}>
            <TextField
                size="small"
                label={label1}
                value={fieldValues.value1}
                onChange={handleInputChange("value1")}
            />
            {showRangeTextFields && (
                <TextField
                    size="small"
                    label={label2}
                    value={fieldValues.value2}
                    onChange={handleInputChange("value2")}
                />
            )}
        </Box>
    );
};